import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  roles: [],
};

const getters = {
  allRoles: (state) => state.roles,
};

const actions = {
  async fetchRoles({ commit }, params = {}) {
    try {
      const response = await axios.get("/roles", { params: prm(params) });
      commit("setRoles", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch roles:", error);
    }
  },
  async createRole({ commit }, role) {
    try {
      const response = await axios.post("/roles", role);
      commit("addRole", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create role:", error);
      throw error;
    }
  },
  async fetchRoleById(_, id) {
    try {
      const response = await axios.get(`/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch role:", error);
      throw error;
    }
  },
  async updateRole({ commit }, role) {
    try {
      const response = await axios.put(`/roles/${role.id}`, role);
      commit("updateRole", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update role:", error);
      throw error;
    }
  },
  async deleteRoleById({ commit }, id) {
    try {
      const response = await axios.delete(`/roles/${id}`);
      commit("removeRole", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete role:", error);
      throw error;
    }
  },
};

const mutations = {
  setRoles(state, roles) {
    state.roles = roles.data;
  },
  addRole(state, role) {
    state.roles.push(role);
  },
  updateRole(state, updatedRole) {
    const index = state.roles.findIndex(
      (role) => role.id === updatedRole.id
    );
    if (index !== -1) {
      state.roles.splice(index, 1, updatedRole);
    }
  },
  removeRole(state, id) {
    state.roles = state.roles.filter(
      (role) => role.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
